import { api } from '../api.js';
import { router } from '../router.js';
import { showToast } from '../utils.js';

/**
 * Requests a reset code. Cognito sends the mail itself (no SES setup exists in v2), and
 * the API deliberately reports success even for an unknown address so this page can't be
 * used to enumerate family accounts.
 */
export function renderForgotPassword() {
    document.getElementById('app').innerHTML = `
        <div class="login-container">
            <h1 class="login-title">Reset password</h1>
            <p class="login-subtitle">We'll email you a code to set a new password.</p>
            <div id="form-error" class="form-error hidden"></div>
            <form id="forgot-form" novalidate>
                <div class="form-group">
                    <label for="email">Email</label>
                    <input type="email" id="email" autocomplete="username" required autofocus>
                </div>
                <button type="submit" id="submit-btn" class="btn btn-primary btn-full-width">Send reset code</button>
                <a href="/login" data-link class="forgot-password-link">Back to sign in</a>
            </form>
        </div>`;

    document.getElementById('forgot-form').addEventListener('submit', async (e) => {
        e.preventDefault();
        const email = document.getElementById('email').value.trim();
        const btn = document.getElementById('submit-btn');
        const error = document.getElementById('form-error');

        btn.disabled = true;
        btn.textContent = 'Sending...';
        try {
            await api.forgotPassword(email);
            showToast('If that address has an account, a code is on its way.', 'success');
            // Carry the address forward so the next screen doesn't ask for it again.
            sessionStorage.setItem('resetEmail', email);
            await router.navigate('/reset-password');
        } catch (err) {
            error.textContent = err.message ?? 'Could not send a reset code';
            error.classList.remove('hidden');
            btn.disabled = false;
            btn.textContent = 'Send reset code';
        }
    });
}
